<template>
  <div class="join-tab">
    <section class="hero">
      <div class="container center reveal">
        <h1>与卓越的人，共创智慧未来</h1>
        <p>我们正在寻找充满好奇心、勇于挑战技术边界的你。加入中鸿云智，一起重塑智慧城市与政务数字化新范式。</p>
      </div>
    </section>

    <section class="benefits">
      <div class="container benefit-grid">
        <article v-for="item in benefits" :key="item.title" class="benefit-card reveal">
          <div class="icon">{{ item.icon }}</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </article>
      </div>
    </section>

    <section class="jobs section">
      <div class="container jobs-wrap">
        <header class="section-head reveal">
          <h2>热招岗位</h2>
        </header>
        <article v-for="item in jobs" :key="item.name" class="job-card reveal">
          <div>
            <div class="title-line">
              <h3>{{ item.name }}</h3>
              <span>{{ item.dept }}</span>
            </div>
            <p>{{ item.info }}</p>
          </div>
          <button type="button" @click="$emit('jump-tab', 'contact')">申请职位</button>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'JoinTab',
  data() {
    return {
      benefits: [
        { icon: '💵', title: '竞争力的薪酬', desc: '13-16薪+绩效奖励' },
        { icon: '☼', title: '带薪年假', desc: '法定年假+公司司龄假' },
        { icon: '🎓', title: '成长赋能', desc: '大厂导师制+专业培训' },
        { icon: '☕', title: '弹性办公', desc: '自由的工作环境与文化' }
      ],
      jobs: [
        { name: '高级Java开发工程师', dept: '研发部', info: '杭州 | 3-5年经验 | 本科以上 | 15k-30k' },
        { name: '数字化产品经理', dept: '产品部', info: '杭州 | 1-3年经验 | 本科以上 | 12k-25k' },
        { name: '运维工程师（政务方向）', dept: '技术支持部', info: '杭州 | 不限经验 | 大专以上 | 8k-15k' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.container {
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
}

.center {
  text-align: center;
}

.hero {
  background: #fff;
  padding: 68px 0;
}

.hero h1 {
  margin: 0 0 10px;
  font-size: clamp(32px, 3.8vw, 48px);
}

.hero p {
  margin: 0 auto;
  max-width: 820px;
  color: #617893;
  line-height: 1.8;
}

.benefits {
  padding: 54px 0;
  background: #f4f7fc;
}

.benefit-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.benefit-card {
  border: 1px solid #e1eaf8;
  border-radius: 20px;
  background: #fff;
  text-align: center;
  padding: 20px;
  transition: transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease;
}

.benefit-card .icon {
  color: #2f67ea;
  font-size: 28px;
}

.benefit-card h3 {
  margin: 10px 0 8px;
  font-size: 22px;
}

.benefit-card p {
  margin: 0;
  color: #617a98;
}

.benefit-card:hover {
  transform: translateY(-5px);
  border-color: #c8daf6;
  box-shadow: 0 14px 24px rgba(19, 50, 101, 0.12);
}

.section {
  padding: 62px 0;
}

.jobs-wrap {
  width: min(980px, calc(100% - 48px));
}

.section-head h2 {
  margin: 0 0 14px;
  font-size: clamp(30px, 3vw, 42px);
}

.job-card {
  border: 1px solid #dce7f8;
  border-radius: 20px;
  background: #fff;
  padding: 18px 22px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
}

.job-card:last-child {
  margin-bottom: 0;
}

.title-line {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-line h3 {
  margin: 0;
  font-size: 22;
}

.title-line span {
  min-height: 24px;
  border-radius: 12px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  background: #ebf3ff;
  color: #2f67ea;
  font-size: 12px;
}

.job-card p {
  margin: 8px 0 0;
  color: #607794;
}

.job-card:hover {
  transform: translateY(-4px);
  border-color: #c9dcfb;
  box-shadow: 0 12px 22px rgba(18, 50, 102, 0.12);
}

.job-card button {
  border: 0;
  min-height: 40px;
  border-radius: 12px;
  padding: 0 24px;
  background: #081431;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.job-card button:hover {
  background: #2b5fd7;
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(27, 63, 142, 0.24);
}

@media (max-width: 1024px) {
  .container {
    width: min(1240px, calc(100% - 36px));
  }

  .jobs-wrap {
    width: min(980px, calc(100% - 36px));
  }

  .benefit-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .container {
    width: min(1240px, calc(100% - 24px));
  }

  .jobs-wrap {
    width: min(980px, calc(100% - 24px));
  }

  .hero p,
  .benefit-card p,
  .job-card p {
    font-size: 14px;
  }

  .benefit-grid {
    grid-template-columns: 1fr;
  }

  .job-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .job-card button {
    width: 100%;
  }
}
</style>
